export default __webpack_public_path__ + "872e95d0ba9909edf86fc9f270743776.svg";